"use strict";

exports.__esModule = true;
exports.FontSizePicker = void 0;
var _react = _interopRequireWildcard(require("react"));
var _core = require("@blueprintjs/core");
var _styledComponents = require("styled-components");
var _excluded = ["value", "availableSizes", "onChange", "style"];
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
function _inheritsLoose(t, o) { t.prototype = Object.create(o.prototype), t.prototype.constructor = t, _setPrototypeOf(t, o); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
var PICKER_POPOVER_CLASSNAME = "vi-font-size-picker-popover";
var GlobalStyle = (0, _styledComponents.createGlobalStyle)(["body{.", "{.", " .", "{max-height:500px;overflow-y:auto;}}}"], PICKER_POPOVER_CLASSNAME, _core.Classes.POPOVER_CONTENT, _core.Classes.MENU);

/**
 * A button which shows a font picker in a popover when clicked.
 */
var FontSizePicker = exports.FontSizePicker = /*#__PURE__*/function (_Component) {
  function FontSizePicker() {
    return _Component.apply(this, arguments) || this;
  }
  _inheritsLoose(FontSizePicker, _Component);
  var _proto = FontSizePicker.prototype;
  _proto.render = function render() {
    var _this$props = this.props,
      value = _this$props.value,
      availableSizes = _this$props.availableSizes,
      onChange = _this$props.onChange,
      style = _this$props.style,
      extra = _objectWithoutPropertiesLoose(_this$props, _excluded);
    return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(GlobalStyle, null), /*#__PURE__*/_react["default"].createElement(_core.Popover, {
      minimal: true,
      position: _core.Position.BOTTOM_LEFT,
      popoverClassName: PICKER_POPOVER_CLASSNAME,
      content: /*#__PURE__*/_react["default"].createElement(_core.Menu, null, /*#__PURE__*/_react["default"].createElement(_core.MenuItem, {
        onClick: function onClick() {
          return onChange(undefined);
        },
        text: "[auto] px"
      }), /*#__PURE__*/_react["default"].createElement(_core.MenuDivider, null), availableSizes.map(function (fontSize) {
        return /*#__PURE__*/_react["default"].createElement(_core.MenuItem, {
          key: fontSize,
          active: fontSize === value,
          onClick: function onClick() {
            return onChange(fontSize);
          },
          text: /*#__PURE__*/_react["default"].createElement("span", {
            style: {
              fontSize: fontSize,
              lineHeight: 1
            }
          }, fontSize, " px")
        });
      }))
    }, /*#__PURE__*/_react["default"].createElement(_core.Button, _extends({}, extra, {
      style: Object.assign({}, style, {
        lineHeight: 1
      })
    }), value ? value + " px" : "[auto] px")));
  };
  return FontSizePicker;
}(_react.Component);
FontSizePicker.defaultProps = {
  availableSizes: [12, 14, 16, 18, 20, 22, 26, 32, 40, 48, 56, 64, 72, 96, 128, 192]
};